// Mock data for Balanced Bites Cafe

export const brandAssets = {
  logo: {
    circular: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/xmubsk15_Green.png",
    green: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/qw7myz06_Green.png",
    black: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/lfdtxipw_Icon%20%28Black%29.png",
  },
  mascot: "https://customer-assets.emergentagent.com/job_b7318edb-5775-4307-b6a0-765bf4d31f37/artifacts/anonzoet_BBC%20di%20.png",
  chef: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/dbmy0esw_WhatsApp%20Image%202026-03-21%20at%2014.54.00.jpeg",
};

export const heroImages = [
  "https://images.unsplash.com/photo-1568992688065-536aad8a12f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBsdW5jaHxlbnwwfHx8fDE3NzMxMzQ5MjV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/flagged/photo-1564697259787-6fc88465d327?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGx1bmNofGVufDB8fHx8MTc3MzEzNDkyOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBsdW5jaHxlbnwwfHx8fDE3NzMxMzQ5MjV8MA&ixlib=rb-4.1.0&q=85"
];

export const foodCategories = [
  {
    name: "Bowls & Tacos",
    image: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/jd5tbxl0_IMG_2915.jpg",
  },
  {
    name: "Wraps",
    image: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/icmdvfss_IMG_8594.jpg",
  },
  {
    name: "Fresh Drinks",
    image: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/hbvuds4k_IMG_8679.jpg",
  },
  {
    name: "Breakfast Items",
    image: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/2zptv0ms_IMG_8659.jpg",
  },
  {
    name: "Energy Bites",
    image: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/kleout4s_IMG_8550.jpg",
  },
  {
    name: "Waffles",
    image: "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/qmnksg2h_IMG_2791.jpg",
  },
];

export const kioskImage = "https://customer-assets.emergentagent.com/job_balanced-bites-3/artifacts/dno1xkaw_Image_1.png";

export const brandPillars = [
  {
    title: "Taste First",
    description: "Food must be delicious before anything else.",
    icon: "chef-hat",
  },
  {
    title: "Health Bonus",
    description: "Balanced ingredients designed for everyday energy.",
    icon: "leaf",
  },
  {
    title: "Warmth Guaranteed",
    description: "A welcoming cafe experience inside corporate spaces.",
    icon: "heart",
  },
];

export const operatingLocations = [
  {
    name: "Corporate Parks",
    icon: "building-2",
  },
  {
    name: "Hospitals",
    icon: "cross",
  },
  {
    name: "Airports",
    icon: "plane",
  },
];

export const contactInfo = {
  whatsapp: "+91 9560209663",
  email: "hello@bbc-cafe.com",
  social: {
    instagram: "https://www.instagram.com/bbc.cafe5/",
    linkedin: "https://www.linkedin.com/company/bbc-balanced-bites-cafe-pvt-ltd/",
    facebook: "https://facebook.com/balancedbites",
  },
};

export const corporateProblems = [
  "Long meetings",
  "Back-to-back deadlines",
  "Low energy during the workday",
  "Limited good food options in offices",
];
